export default __webpack_public_path__ + "static/UCarouselZoom-9b2bbd9f4ab868eda0b9db998149f31a.gif";